import { SWRFetcher } from '@commenda/utils/logical-backend-fetcher';
import { LegacyDocumentType } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

type GetFilesByType = {
  companyId?: number;
  corporationId?: number;
  types: LegacyDocumentType[];
  workRequestId?: string;
  enabled?: boolean;
};

export function useGetFilesByTypes({
  companyId,
  corporationId,
  types,
  workRequestId,
  enabled = true,
}: GetFilesByType) {
  let url = 'file/file-types';

  const urlQuery = new URLSearchParams();

  //add types to query params
  if (types.length > 0) {
    types.forEach((type) => urlQuery.append('documentTypes', type));
  }
  //add corporationId to query params
  if (corporationId) {
    urlQuery.append('corporationId', corporationId.toString());
  }
  if (companyId) {
    urlQuery.append('companyId', companyId.toString());
  }

  if (workRequestId) {
    urlQuery.append('workRequestId', workRequestId);
  }

  if (urlQuery.toString() !== '') {
    url += `?${urlQuery.toString()}`;
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: {
      id: number;
      corporationId: number;
      fileUrl: string;
      fileName: string;
      documentType: LegacyDocumentType;
      explicitDocumentType: string;
      createdAt: string;
      workRequestId: string;
    }[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    enabled ? url : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
